import PatientForm from './PatientForm';
import EmailField from './EmailField';
import LegalLink from './LegalLink';
import DOBField, { DOBGroup } from './DOBField';

export default PatientForm;

export { EmailField, LegalLink, DOBField, DOBGroup };
